export default {
  // 导航菜单
  nav: {
    home: '首页',
    store: '产品介绍',
    about: '关于我们',
    news: '企业新闻',
    applications: '应用场景',
    contact: '联系我们'
  },
  // 语言切换
  language: {
    switch: '切换语言',
    chinese: '中文',
    english: 'English'
  },
  // 英雄区域
  hero: {
    title: '自然无忧，健康生活',
    subtitle: '为您提供纯天然、无污染的优质产品，让生活更加健康美好',
    viewNow: '立即查看',
    learnMore: '了解更多'
  },
  // 产品区域
  store: {
    title: '产品介绍',
    subtitle: '精选优质天然产品，为您的健康生活护航',
    viewNow: '立即查看',
    currency: '￥'
  },
  // 产品特点
  features: {
    title: '产品特点',
    subtitle: '自然无忧系列产品的核心优势',
    feature1: {
      title: '天然环保',
      description: '采用植物纤维原料，可完全自然降解，环保无污染'
    },
    feature2: {
      title: '卫生安全',
      description: '一次性使用，避免交叉感染，确保卫生安全'
    },
    feature3: {
      title: '舒适便捷',
      description: '加厚珍珠纹水刺无纺布，触感舒适，使用便捷'
    },
    feature4: {
      title: '应用广泛',
      description: '适用于酒店、医院、美容院、养老院等多种场所'
    }
  },
  // 关于我们
  about: {
    title: '关于我们',
    subtitle: 'About us',
    content: '自然无忧系列产品是由港盛蓝营主理，原材料使用植物纤维（加厚珍珠纹水刺无纺布）加工而成的一次性床单、被套、枕套、浴巾和面巾等产品，可提供OEM/ODM贴牌加工服务，适用于酒店、医院、美容院、养老院、高端民宿等领域。我们致力于生产与环保实践，采用可完全自然降解的环保材料制成，我们的产品天然优质、卫生安全，旨在为用户提供更加健康、舒适、环保的使用体验。'
  },
  // 新闻区域
  news: {
    title: '企业最新动态',
    subtitle: '新闻中心',
    empty: '还没有发布任何博客文章。',
    readMore: '查看详情'
  },
  // 应用场景
  applications: {
    title: '产品应用场景',
    subtitle: '一次性床单被套适用于多种场所，酒店、医院、露营、家庭公寓',
    travel: {
      title: '旅行和露营',
      description: '旅行和露营中使用一次性床单被套是明智之举，轻便易携带，可以在任何地方使用，并且不需要担心清洁和维护。一次性床单被套还可以减少行李重量，提高旅行和露营的便利性。'
    },
    hotel: {
      title: '酒店和旅馆',
      description: '酒店和旅馆使用一次性床单被套可以确保客人在每次入住时都获得干净的床上用品，同时也方便了酒店的清洁工作。一次性床单被套还可以减少洗涤成本和时间，提高酒店的效率。'
    },
    home: {
      title: '家庭和公寓出租',
      description: '家庭和公寓出租中使用一次性床单被套可以确保客人获得干净的床上用品，并且可以减少清洁和维护的工作量。一次性床单被套还可以提高出租房屋的卫生标准，增加客户满意度。'
    },
    medical: {
      title: '医院和诊所',
      description: '医院和诊所使用一次性床单被套可以确保病床的卫生和安全，并减少交叉感染的风险。一次性床单被套还可以减少清洁成本和时间，提高医疗设施的效率。'
    },
    summaryTitle: '这些场所都需要提供干净卫生的床上用品，而一次性床单被套可以很好地满足这一需求。',
    summaryDescription: '自然无忧一次性床单被套在不同场所都有着广泛的应用，为用户提供了干净卫生的床上用品，同时也提高了各个场所的效率和卫生标准。'
  },
  // 联系我们
  contact: {
    title: '联系我们',
    subtitle: '我们期待与您取得联系',
    address: '地址',
    addressText: '广东省惠州市惠东县白花镇太阳坳工业区太祥路88号华夏光大白花工业园',
    phone: '电话',
    phoneText: '400-000-1317',
    email: '邮箱',
    emailText: '1620294866@qq.com',
    form: {
      name: '您的姓名',
      email: '您的邮箱',
      phone: '您的电话',
      message: '您的留言',
      submit: '发送留言',
      submitting: '发送中...',
      validation: '请填写姓名、邮箱和留言内容',
      emailInvalid: '请输入正确的邮箱格式',
      phoneInvalid: '请输入正确的电话号码格式'
    },
    submitSuccess: '感谢您的留言，我们会尽快与您联系！',
    submitError: '发送失败，请稍后重试'
  },
  // 页脚
  footer: {
    company: '惠州市礼兴日用品有限公司@ 2021',
    aboutUs: '关于我们',
    ourConcept: '我们的理念',
    ourHistory: '我们的历史',
    contactUs: '联系我们',
    phone: '电话：400-000-1317',
    email: 'EMAIL:  1620294866@qq.com',
    viewIntroduction: '查看介绍'
  }
}
